import React from 'react';
import _ from "lodash";
import { Image, View } from "react-native";
import Text from "theme/Text";
import { textProps } from "styles/text";
import { ThemedSizes } from "styles/themed";
import { AppRoutes } from "navigations/app-routes";
import { constantsActive } from "utils/constants/constants";
import { useNavigation } from '@react-navigation/native'
import { UserAvatarConfidantStyles, UserAvatarEroStyles, UserAvatarSizeStyles, UserAvatarStyles } from 'styles/components/atoms/UserAvatar'
import i18n from 'utils/i18n'
import LoadingComponent from 'components/atoms/Loading'
import ThemedPressable from 'components/atoms/ThemedPressable'
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import HelperString from 'utils/helper-string'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import isEqual from 'react-fast-compare'


const namePrefixes = [
	'van',
	'ter',
	'ten',
	'der',
	'den',
	'de'
];

const UserAvatar = ({ onPress, size = ThemedSizes.S, employee = {}, style = {}, loading = false, showIconConfidant = true, showIconEro = true, highlight = false, navigation, children }) => {
	const isResponseEmployee = _.get( employee, 'response_employee', constantsActive.NO ) === constantsActive.YES;
	const isConfidant = _.get( employee, 'confidant', constantsActive.NO ) === constantsActive.YES;
	const responseEmployeeEnabled = isResponseEmployee && showIconEro && HelperSetting.isYes( settingsConstants.ERO_ENABLE );
	const confidantEnabled = isConfidant && showIconConfidant && HelperSetting.isYes( settingsConstants.CONFIDANT_ENABLE );
	
	navigation = navigation ?? useNavigation()
	
	const onPressEro = () => {
		navigation?.navigate( AppRoutes.ERO_COWORKER, {
			employee: employee,
		});
	}
	
	const name		= _.get( employee, 'name', null );
	let photoUrl	= _.get( employee, 'photo_url', null );
	
	const photoStyles = [
		UserAvatarStyles.avatarImage,
		UserAvatarSizeStyles[ size ].avatarImage,
		( responseEmployeeEnabled ? UserAvatarStyles.avatarWithEro : null ),
		( confidantEnabled ? UserAvatarStyles.avatarWithConfidant : null ),
	]
	
	const textStyles = [
		UserAvatarStyles.avatarText,
		( responseEmployeeEnabled ? UserAvatarStyles.avatarWithEro : null ),
		( confidantEnabled ? UserAvatarStyles.avatarWithConfidant : null ),
	]
	
	const avatarViewStyle = [
		UserAvatarStyles.avatarContainer,
		UserAvatarSizeStyles[ size ].avatarContainer,
		( responseEmployeeEnabled ? UserAvatarStyles.avatarWithEro : null ),
		( confidantEnabled ? UserAvatarStyles.avatarWithConfidant : null ),
		style,
		( highlight ? UserAvatarStyles.highlight : {} )
	]
	
	const avatarViewEroStyle = [
		UserAvatarEroStyles.container,
		confidantEnabled ? UserAvatarEroStyles.withConfidant : {}
	]
	
	if( photoUrl !== null ){
		photoUrl = { uri: photoUrl };
	}
	
	let avatar = (
		<LoadingComponent size={ 's' } />
	);

	if( !loading ) {
		switch( true ) {
			case photoUrl !== null  && photoUrl !== '':
				avatar = (
					<Image
						style={ photoStyles }
						source={ photoUrl }
					/>
				);
				break;

			case name !== null:
				let clean_name = name;
				_.forEach( namePrefixes, ( namePrefix ) => {
					clean_name = clean_name.replaceAll(new RegExp(namePrefix,'ig'), '');
				});

				const acronym = clean_name.match( /\b(\w)/g ).join( '' );
				
				avatar = (
					<Text
						{ ...textProps.fit }
						style={ textStyles }>
						
						{ acronym }
					</Text>
				);
				break;
				
			default:
				avatar = (
					<Text
						style={ textStyles }>
						
						?
					</Text>
				);
		}
	}

	if( responseEmployeeEnabled ) {
		if( onPress === null ) {
			onPress = onPressEro
		}
	}
	
	const avatarView = [
		<View
			key={ HelperString.hash('user-avatar-container') }
			style={ avatarViewStyle }>
			
			{ avatar }
		</View>
	]
	
	if( responseEmployeeEnabled ) {
		avatarView.push(
			<View
				key={ HelperString.hash('user-avatar-container-ero') }
				style={ avatarViewEroStyle }>
				
				<Icon
					icon={ IconSystemConstants.ERO }
					style={ UserAvatarEroStyles.icon }
				/>
				
				<Text
					style={ UserAvatarEroStyles.text }>
					
					{ i18n.t( 'constants.ero' ) }
				</Text>
			</View>
		)
	}
	
	if( confidantEnabled ){
		avatarView.push(
			<View
				key={ HelperString.hash('user-avatar-container-confidant') }
				style={ UserAvatarConfidantStyles.container }>
				
				<Text style={ UserAvatarConfidantStyles.text }>
					{ i18n.t( 'constants.confidant' ) }
				</Text>
			</View>
		)
	}
	
	if( children ) {
		avatarView.push( children );
	}
	
	if ( !_.isFunction( onPress ) ) {
		return avatarView;
	}
	
	return (
		<ThemedPressable
			onPress={ onPress }>
			
			{ avatarView }
		</ThemedPressable>
	);
}

export default React.memo( UserAvatar, isEqual );
